export const CUSTOM_NODE = {
  Start: "start",
  Conversation: "conversation",
  Greeting: "greeting",
  HumanAgentHandoff: "human_agent_handoff",
  LanguageDetection: "language_detection",
  HangUp: "hang_up",
  GoogleSheets: "google_sheets",
  Sequence: "sequence",
};
